// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import removeIcon from "../../assets/icons/deleteRed.svg"; // Import remove icon
type WorkingHour = {
  days: number[];
  hour_from: string;
  hour_to: string;
};
type propsType = {
  workingHours: WorkingHour[];
  daysOptions: { value: string; label: string }[];
  removeWorkingHour: (id: number) => void;
};
const WorkingHoursTable = ({
  workingHours,
  daysOptions,
  removeWorkingHour,
}: propsType) => {
  return (
    <div className="mt-6 h-[120px]   overflow-y-auto customScroll">
      {workingHours.map((entry, index) => (
        <div
          key={index}
          className="flex justify-between items-center p-4  rounded mb-2"
        >
          <span className="text-sm w-full">
            {entry.days.length == 7
              ? "all days"
              : entry.days.length == 5 &&
                !entry.days.includes(5) &&
                !entry.days.includes(6)
              ? "WeekDays"
              : daysOptions
                  .filter((option) => entry.days.includes(option.value))
                  .map((option) => option.label)
                  .join(", ")}
          </span>
          <span className="text-sm w-full">
            {entry.hour_from} to {entry.hour_to}
          </span>

          <button
            type="button"
            onClick={() => removeWorkingHour(index)}
            className="ml-4 w-[100px]"
          >
            <img loading="lazy" src={removeIcon} alt="Remove" className=" cursor-pointer" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default WorkingHoursTable;
